import { api } from '@/api';
import { TrackItTaskResultForEvaluation, TrackItTaskWorkResultDto } from '@/api/generator';
import { useJobOccurrence } from './useJobOccurrence';

export function useTrackItWorkStepPreview() {
  const { jobOccurrence } = useJobOccurrence();

  async function fetchPreview(
    trackItMeasurementId: number,
    workStepId: string,
    additionalResults: TrackItTaskResultForEvaluation[],
  ): Promise<TrackItTaskWorkResultDto | undefined> {
    if (!jobOccurrence.value.id) {
      return undefined;
    }

    const { result, success } = await api.trackItImportApi.getTrackItExecutionPreviewForWorkStep({
      importTrackItMeasurementForWorkStepDto: {
        trackItMeasurementId,
        jobOccurrenceId: jobOccurrence.value.id,
        workStepId,
        additionalResults,
      },
    });

    return success ? result : undefined;
  }

  return { fetchPreview };
}
